import script from "./ShortcutItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortcutItem.vue?vue&type=script&setup=true&lang=js"

import "./ShortcutItem.vue?vue&type=style&index=0&id=3bbe413e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bbe413e"]])

export default __exports__